import React from 'react';

const EsdcReportingNotesHelp = () => (
  <div>
    <p>
      Use submission notes to capture cross-team follow-ups, outstanding questions for ESDC, or reminders for the next
      review meeting. Notes provide lightweight audit context without leaving the dashboard.
    </p>
  </div>
);

EsdcReportingNotesHelp.aiContext = `
Widget help: Reporting submission notes and follow-up actions.
`;

export default EsdcReportingNotesHelp;
